import { create } from 'zustand'

export type LiveQuotesStatus =
  | 'unavailable' // user has no Schwab attachment; no stream possible
  | 'closed'      // legacy: stream is now always-on; kept for consumers' status unions
  | 'connecting'  // ws opened, awaiting login or initial data
  | 'online'      // upstream Schwab stream connected
  | 'offline'     // ws closed / disconnected; fallback to REST poll

interface LiveQuotesState {
  status: LiveQuotesStatus
  setStatus: (status: LiveQuotesStatus) => void
}

export const useLiveQuotesStore = create<LiveQuotesState>((set) => ({
  status: 'unavailable',
  setStatus: (status) => set({ status }),
}))
